import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './index.css'

export default class RadioField extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.string
  }

  handleChange = (e) => {
    const { onChange } = this.props
    onChange && onChange(e.target.checked)
  }

  render() {
    const { label, name, checked, error, id, value } = this.props

    return (
      <div className="form-group-radio">
        <input id={id} name={name} type="radio" value={value} checked={checked} onChange={this.handleChange} className="css-radio" />
        <label className="css-radio-label" htmlFor={id} onClick={this.handleChange}>{ label }</label>
        { error && <div className="error">{ error}</div> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RadioField/index.js